/* ============
 * Create Page
 * ============
 *
 * This is the page for adding order.
 */
import Forms from './../../../../utils/forms/forms';
import { mapGetters } from 'vuex';
import clientService from './../../../../services/client';
import productService from './../../../../services/product';
import orderTypeService from './../../../../services/orderType';
import orderService from './../../../../services/order';
import batchService from './../../../../services/batch';
import warehouseService from './../../../../services/warehouse';
import projectService from './../../../../services/project';
import organizationSettingsService from './../../../../services/organizationSettings';
import debounce from 'debounce';
import moment from 'moment';

export default {
  data() {
    return {
      form: new Forms({
        clientId: {
          type: 'select',
          value: '',
        },
        orderTypeId: {
          value: '',
          type: 'select',
        },
        projectId: {
          type: 'select',
          value: '',
        },
        createdAt: {
          type: 'date',
          value: '',
        },
        date: {
          type: 'date',
          value: '',
        },
        time: {
          type: 'time',
          value: '',
        },
        duration: {
          type: 'number',
          value: '',
        },
        details: {
          type: 'textarea',
          value: '',
        },
      }),
      loading: true,
      contentLoading: false,
      hasProduction: false,
      errors: [],
    };
  },

  computed: {
    ...mapGetters({
      clients: 'allClientOptions',
      products: 'allProducts',
      orderTypes: 'orderTypes',
      warehouses: 'allWarehouses',
      batches: 'allBatches',
      account: 'account',
      settings: 'organizationSettings',
      allProjects: 'allProjects',
    }),
  },

  watch: {

    allProjects(allProjects) {
      const options = allProjects.map(project => ({
        id: project.id,
        name: project.name,
      }));
      this.form.setOptions('projectId', [{ id: 0, name: ' ' }, ...options]);
    },

    'form.clientId': function (clientId) {
      // eslint-disable-next-line radix
      const client = this.clients.find(item => item.id === parseInt(clientId));
      if (typeof client !== 'undefined') {
        this.form.setFieldValue('projectId', client.projectId);
      } else {
        this.form.setFieldValue('projectId', 0);
      }
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} clients    The clients list.
     */
    clients(clients) {
      this.form.setOptions('clientId', clients.map(c => ({ id: c.id, name: c.companyName || `${c.firstName} ${c.lastName}` })));
    },

    account(account) {
      let hasInventory = false;
      if (account.modules.length > 0) {
        for (let i = 0; i < account.modules.length; i++) {
          if (account.modules[i].name === 'Inventory') {
            // this.form.hideField('warehouseId');
            hasInventory = true;
          }
        }
      }
      if (hasInventory) {
        this.form.hideField('warehouseId');
      }
    },
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} products    The products list.
     */
    products(products) {
      let hasInventory = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Inventory') {
            hasInventory = true;
          }
        }
      }

      this.form.setOptions('productId', products.map(c => ({ id: c.id, name: `${c.name} ` })));
      /* if(!hasInventory){


      }*/
    },

    batches(batches) {
      this.form.setOptions('batchId', batches.map(c => ({
        id: c.id,
        name: c.code,
      })));
    },

    warehouses(warehouses) {
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Inventory') {
            this.form.setOptions('warehouseId', warehouses.items);
          }
        }
      }
    },
    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} orderTypes    The order types list.
     */
    orderTypes(orderTypes) {
      if (!orderTypes.length) return;
      
      let types = orderTypes.filter(t => t.name !== 'EDI');
      if (types.length === 1) {
        this.form.hideField('orderTypeId');
        this.form.orderTypeId = types[0].id;
        return;
      }

      types = types.map(allowedType => ({
        id: allowedType.id,
        name: this.$t(`static.orders.types.${allowedType.name.toLowerCase()}`),
      }));
      this.form.orderTypeId = types[0].id;
      this.form.setOptions('orderTypeId', types);
    },

    /**
     * Watches order type to hide or show appointment config.
     *
     * @param  {Integer} typeId    The order type id.
     */
    'form.orderTypeId': function (typeId) {
      const type = this.orderTypes.filter(t => (
        typeId.toString() === t.id.toString()
      ))[0];

      if (type.name === 'Appointment') {
        this.showAppointmentConfig();
        Promise.all([
          productService.all(),
        ]).then(() => {

        });
      } else {
        // this.hideAppointmentConfig();
        // if(this.form.warehouseId !=''){
        //      Promise.all([
        //       warehouseService.products(this.form.warehouseId)
        //       ]).then((data) => {
        //          this.form.setOptions('productId', data[0].map(c => (
        //             { id: c.productId, name:`${c.product.name} | available: ${c.qty}` }
        //           )));
        //       });
        // }else{
        //   //this.form.setOptions('productId',[]);
        // }
      }
    },

    'form.warehouseId': function (warehouseId) {
      this.contentLoading = true;
      if (this.hasProduction) {
        Promise.all([
          batchService.all({ warehouse_id: warehouseId, for_select: 1 }),
        ]).then(() => {
          this.contentLoading = false;
        });
      }
    },

    'form.productId': function (product) {
      if (product.id && this.hasProduction) {
        this.contentLoading = true;
        Promise.all([
          batchService.all({
            warehouse_id: this.form.warehouseId,
            product_id: product.id,
            for_select: 1,
          }),
        ]).then(() => {
          if (this.batches.length) {
            this.form.batchId = this.batches[0].id;
          } else {
            this.form.batchId = null;
          }
          this.contentLoading = false;
        });
      }
    },
  },

  created() {
    this.hideAppointmentConfig();
    this.loading = true;
    this.form.createdAt = moment().format('YYYY-MM-DD');

    Promise.all([
      organizationSettingsService.show(),
      clientService.allOptions(),
      // productService.all(),
      warehouseService.all(),
      orderTypeService.all(),
      batchService.all({ has_warehouse_transaction: 1, for_select: 1 }),
      projectService.all(),
    ]).then((data) => {
      this.loading = false;
      this.form.setDisplays('productId', data[0].productInfoDisplay);
      this.form.warehouseId = this.settings.defaultWarehouse;
      const self = this;
      this.$nextTick(() => {
        self.$refs.form.$refs.clientId.$refs.clientId.$el.click();
      });
      this.checkProjectModule();
    });
  },

  methods: {

    checkProjectModule() {
      this.form.hideField('projectId');
      let hasProject = false;
      if (this.account.modules.length > 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name === 'Project') {
            hasProject = true;
          }
        }
      }
      if (hasProject) {
        this.form.showField('projectId');
      }
    },

    /**
     * Show fields related to appointment module.
     */
    showAppointmentConfig() {
      this.form.showField('date');
      this.form.showField('time');
      this.form.showField('duration');
      this.form.showField('details');
      this.form.hideField('warehouseId');
      this.form.hideField('projectId');
    },

    searchMethod(search, field) {
      this.form.setAttrValue('productId', 'loading', true);
      // console.log(field);

      return Promise.all([
        productService.search({ search, filter: 'active', warehouse_id: this.form.warehouseId }),
      ]);
    },
    /**
     * Hide fields related to appointment module.
     */
    hideAppointmentConfig() {
      this.form.hideField('date');
      this.form.hideField('time');
      this.form.hideField('duration');
      this.form.hideField('details');

      let hasInventory = false;
      if (this.account.modules.length > 0) {
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name == 'Inventory') {
            // this.form.hideField('warehouseId');
            hasInventory = true;
          }
          if (this.account.modules[i].name === 'Production') {
            this.hasProduction = true;
          }
        }
      }
      if (this.account.allowProducerBatches) {
        this.hasProduction = true;
      }

      if (!hasInventory) {
        this.form.hideField('warehouseId');
      }
      if (!this.hasProduction) {
        this.form.hideField('batchId');
      }
      // this.form.hideField('warehouseId');
    },

    /**
     * Method to store the order.
     */
    store() {
      this.form.loading = true;
      const data = this.form.data();
      orderService.store(data)
        .then((r) => {
          this.$router.push({
            name: 'orders.edit',
            params: {
              id: r.id,
            },
          });
        }).catch((errors) => {
          this.form.recordErrors(errors);
          this.form.loading = false;
        });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/orders/create/create.js